module.exports = __webpack_public_path__ + "static/media/user.143eee92.svg";